export enum specimenUOM {
  Default = '',
  Straws = 'Straws',
  Pellets = 'Pellets',
  Embryo = 'Embryo',
  Goblet = 'Goblet',
}
